import abstractStorage from './abstract-storage';

export default abstractStorage;